import { SvgIcon } from '@npco/zeller-design-system'

import {
  DebitCardTransactionStatusV2,
  DebitCardTransactionTypeV2,
} from 'types/gql-global-types'
import { Tooltip } from 'components/Tooltip'
import { component } from 'translations'

import {
  StyledPendingIconWrapper,
  StyledWrapper,
} from './AccountTransactionTypeIcon.styled'
import {
  getTransactionIcons,
  pendingIcon,
} from './AccountTransactionTypeIcon.utils'

interface Props {
  type: DebitCardTransactionTypeV2
  status?: DebitCardTransactionStatusV2
  color?: string
}

export const AccountTransactionTypeIcon = ({ status, type, color }: Props) => {
  const transactionTypeIcon = getTransactionIcons({ type })

  return (
    <StyledWrapper>
      <SvgIcon color={color}>{transactionTypeIcon}</SvgIcon>
      {status === DebitCardTransactionStatusV2.PROCESSING && (
        <StyledPendingIconWrapper>
          <Tooltip
            tooltipIcon={
              <SvgIcon width="0.25rem" height="0.25rem">
                {pendingIcon}
              </SvgIcon>
            }
          >
            {component.transaction.statusBadge.pending}
          </Tooltip>
        </StyledPendingIconWrapper>
      )}
    </StyledWrapper>
  )
}
